<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    position="right"
  >
    <div
      class="!w-[500px] !max-w-[500px] h-screen bg-[#ffffff] dark:bg-gray-800 !rounded-2xl"
    >
      <div class="h-auto flex flex-col p-6 space-y-6">
        <!-- Header -->
        <div
          class="text-center pb-6 border-b border-gray-200 dark:border-gray-700"
        >
          <h2 class="text-2xl font-bold text-gray-800 dark:text-gray-100">
            设置
          </h2>
          <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">
            设置与工具
          </p>
        </div>

        <!-- Utility Section -->
        <div class="space-y-4">
          <h3
            class="text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2"
          >
            <q-icon name="build" class="text-purple-500" />
            工具功能
          </h3>

          <button
            @click="$q.fullscreen.toggle()"
            class="w-full px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <div class="flex items-center justify-center gap-3">
              <q-icon
                :name="
                  $q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'
                "
                class="text-xl"
              />
              <span>{{
                $q.fullscreen.isActive ? "退出全屏" : "全屏显示"
              }}</span>
            </div>
          </button>

          <button
            @click="handleRefresh"
            class="w-full px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <div class="flex items-center justify-center gap-3">
              <q-icon name="refresh" class="text-xl" />
              <span>刷新页面</span>
            </div>
          </button>

          <q-btn
            label="HU cps_tool 信号工具"
            color="primary"
            @click="router.push('/hu-cps-tool')"
            class="w-full rounded-xl"
          />

          <button
            v-if="domainControlStore.showVConsole"
            @click="domainControlStore.sentryTest"
            class="w-full px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <div class="flex items-center justify-center gap-3">
              <q-icon name="bug_report" class="text-xl" />
              <span>Sentry Test</span>
            </div>
          </button>

          <button
            v-if="isNative"
            @click="handleExitApp"
            class="w-full px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <div class="flex items-center justify-center gap-3">
              <q-icon name="exit_to_app" class="text-xl" />
              <span>退出应用</span>
            </div>
          </button>

          <q-btn
            label="进入车辆测试集合"
            color="primary"
            @click="router.push('/car-tests')"
            class="w-full rounded-xl"
          />
        </div>

        <!-- Settings Section -->
        <div class="space-y-4">
          <h3
            class="text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2"
          >
            <q-icon name="settings" class="text-indigo-500" />
            设置选项
          </h3>

          <div class="space-y-3">
            <div
              class="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 space-y-4"
            >
              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >显示 debug 功能</label
                >
                <q-toggle
                  color="blue"
                  :model-value="domainControlStore.showDebugPanel"
                  @update:model-value="domainControlStore.changeShowDebugPanel"
                />
              </div>

              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >深色模式</label
                >
                <q-toggle
                  color="purple"
                  :model-value="$q.dark.isActive"
                  @update:model-value="$q.dark.toggle()"
                />
              </div>

              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >显示 vConsole</label
                >
                <q-toggle
                  color="green"
                  :model-value="domainControlStore.showVConsole"
                  @update:model-value="domainControlStore.changeShowVConsole"
                />
              </div>
              <!-- 蓝牙相关目前不用 -->
              <!-- <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >显示日志</label
                >
                <q-toggle
                  color="orange"
                  :model-value="domainControlStore.printLog"
                  @update:model-value="domainControlStore.changePrintLogStatus"
                />
              </div> 
              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >显示时间间隔</label
                >
                <q-toggle
                  color="teal"
                  :model-value="domainControlStore.printInterval"
                  @update:model-value="
                    domainControlStore.changePrintIntervalStatus
                  "
                />
              </div> -->

              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >日志打印订阅数据</label
                >
                <q-toggle
                  color="deep-orange"
                  :model-value="domainControlStore.printSubscribeData"
                  @update:model-value="
                    domainControlStore.changePrintSubscribeData
                  "
                />
              </div>

              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >开启 Mock 数据</label
                >
                <q-toggle
                  color="amber"
                  :model-value="domainControlStore.enableMock"
                  @update:model-value="domainControlStore.changeEnableMock"
                />
              </div>

              <div class="flex items-center justify-between">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                  >显示订阅播放控制按钮</label
                >
                <q-toggle
                  color="cyan"
                  :model-value="domainControlStore.showSubscribePlaybackControl"
                  @update:model-value="
                    domainControlStore.changeShowSubscribePlaybackControl
                  "
                />
              </div>

              <div class="space-y-2">
                <label
                  class="text-gray-700 dark:text-gray-300 text-sm font-medium block"
                  >路面预瞄展示距离</label
                >
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  仅控制 3D 路面场景雾效与机位量程（米）；HUD 雷达固定 15m，列表样式不随此项变化
                </p>
                <q-select
                  dense
                  outlined
                  emit-value
                  map-options
                  :options="previewRangeSelectOptions"
                  :model-value="domainControlStore.previewSceneDisplayRangeM"
                  @update:model-value="
                    domainControlStore.changePreviewSceneDisplayRangeM($event)
                  "
                />
              </div>

              <div class="flex items-center justify-between">
                <div>
                  <label
                    class="text-gray-700 dark:text-gray-300 text-sm font-medium"
                    >HUD 垂向加速度曲线</label
                  >
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    使用 SusIMUAccVert，仅曲线无坐标轴；默认关闭
                  </p>
                </div>
                <q-toggle
                  color="cyan"
                  :model-value="domainControlStore.showHudSusImuAccVertChart"
                  @update:model-value="
                    domainControlStore.changeShowHudSusImuAccVertChart
                  "
                />
              </div>
            </div>

            <div
              v-if="domainControlStore.printInterval"
              class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700/50 rounded-xl p-4"
            >
              <div class="flex items-center justify-between">
                <span
                  class="text-blue-700 dark:text-blue-300 text-sm font-medium"
                  >时间间隔:</span
                >
                <span class="text-blue-800 dark:text-blue-200 font-semibold">{{
                  domainControlStore.notifyInterval
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Recording Section -->
        <div class="space-y-4">
          <h3
            class="text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2"
          >
            <q-icon name="fiber_manual_record" class="text-red-500" />
            录制功能
          </h3>

          <div class="space-y-3">
            <div class="flex gap-3">
              <button
                v-if="domainControlStore.uploadRecordListLoading"
                disabled
                class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-xl shadow-lg transition-all duration-300 opacity-75 cursor-not-allowed"
              >
                <div class="flex items-center justify-center gap-3">
                  <q-spinner color="white" size="1.5em" />
                  <span>上传中...</span>
                </div>
              </button>

              <button
                v-else-if="!domainControlStore.isRecording"
                @click="domainControlStore.startRecord"
                class="flex-1 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div class="flex items-center justify-center gap-3">
                  <q-icon name="play_arrow" class="text-xl" />
                  <span>开始录制</span>
                </div>
              </button>

              <button
                v-else-if="domainControlStore.isRecording"
                @click="domainControlStore.endRecord"
                class="flex-1 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div class="flex items-center justify-center gap-3">
                  <q-icon name="stop" class="text-xl" />
                  <span>停止录制</span>
                </div>
              </button>
            </div>

            <div
              v-if="domainControlStore.isRecording"
              class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700/50 rounded-xl p-4"
            >
              <div class="flex items-center gap-3">
                <div
                  class="w-3 h-3 bg-red-500 rounded-full animate-pulse"
                ></div>
                <span class="text-red-700 dark:text-red-300 font-medium">
                  录制中... 已录制
                  {{ domainControlStore.recordList.length }} 条数据
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- App Info Section -->
        <div v-if="isNative" class="space-y-4">
          <h3
            class="text-lg font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2"
          >
            <q-icon name="info" class="text-blue-500" />
            应用信息
          </h3>

          <div class="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 space-y-3">
            <div class="flex items-center justify-between">
              <span class="text-gray-600 dark:text-gray-400">应用版本:</span>
              <span class="text-gray-800 dark:text-gray-200 font-medium">{{
                appInfo?.appVersion || "加载中..."
              }}</span>
            </div>

            <div class="flex items-center justify-between">
              <span class="text-gray-600 dark:text-gray-400">提交哈希:</span>
              <span
                class="text-gray-800 dark:text-gray-200 font-medium text-xs font-mono"
              >
                {{ appInfo?.commitHash || "加载中..." }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useDomainControlStore } from "@/stores/domainControl";
import { PREVIEW_SCENE_DISPLAY_RANGE_OPTIONS } from "@/constants/previewSceneDisplay";

defineProps<{ modelValue: boolean }>();
defineEmits<{ "update:modelValue": [value: boolean] }>();
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { isNative } from "@/utils/capacitor";
import ForceExit from "@/utils/capacitor/forceExitPlugin";
import { getAppInfo } from "@/utils/capacitor/appPlugin";

const $q = useQuasar();
const router = useRouter();
const domainControlStore = useDomainControlStore();
const appInfo = ref<{ appVersion?: string; commitHash?: string } | null>(null);

const previewRangeSelectOptions = PREVIEW_SCENE_DISPLAY_RANGE_OPTIONS.map(
  (m) => ({ label: `${m} m`, value: m })
);

const handleRefresh = () => {
  window.location.reload();
};

const loadAppInfo = async () => {
  try {
    const info = await getAppInfo();
    appInfo.value = info;
  } catch (error) {
    console.error("获取应用信息失败:", error);
  }
};

onMounted(() => {
  if (isNative) {
    loadAppInfo();
  }
});

const handleExitApp = async () => {
  try {
    if (domainControlStore.isRecording) {
      await domainControlStore.endRecord();
    }
    await ForceExit.forceExit();
  } catch (error) {
    console.error("Error exiting app:", error);
    $q.notify({
      type: "negative",
      message: "退出应用失败",
      position: "top",
    });
  }
};
</script>

<style></style>
